<template>
  <div
    class="RsvpRangeInput"
    :class="{
      'RsvpRangeInput--shouldSlide': shouldSlide,
    }"
    :data-direction="direction"
  >
    <strong
      class="RsvpRangeInput__header"
      data-testid="header"
    >
      <Transition>
        <span
          :key="String(!!modelValue)"
          class="RsvpRangeInput__headerTitle"
        >{{ formattedHeader }}</span>
      </Transition>
    </strong>

    <div class="RsvpRangeInput__trackContainer">
      <div class="RsvpRangeInput__track">
        <div
          v-for="(_tick, i) in ticks"
          :key="i"
          class="RsvpRangeInput__trackTick"
          :data-size="(i + 1) % 2 !== 0 ? 'large' : 'small'"
          :style="{
            left: `${100 / segmentCount + i / (ticks.length - 1) * (100 - 100 / segmentCount)}%`,
          }"
        />
      </div>

      <svg
        class="RsvpRangeInput__thumb"
        width="32"
        height="32"
        viewBox="0 0 20 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="10"
          cy="16"
          r="3"
          fill="#fff"
        />
        <template v-if="modelValue === null">
          <path
            d="M8.10059 0.309169C10.5491 -0.50812 13.246 0.331599 14.7969 2.39511C15.1288 2.83649 15.0399 3.46349 14.5986 3.7955C14.1572 4.12746 13.5302 4.03871 13.1982 3.59725C12.1645 2.22126 10.366 1.6608 8.7334 2.20565C7.10101 2.75056 6.00018 4.27867 6 5.9996V7.9996H18C19.1044 7.99965 19.9997 8.89524 20 9.9996V21.9996C19.9999 23.1041 19.1045 23.9995 18 23.9996H2C0.895453 23.9995 5.52232e-05 23.1041 0 21.9996V9.9996C0.000276174 8.89524 0.89559 7.99965 2 7.9996H4V5.9996C4.00025 3.41819 5.652 1.12662 8.10059 0.309169ZM10 12.9996C8.34328 12.9996 7.00022 14.3429 7 15.9996C7 17.6565 8.34315 18.9996 10 18.9996C11.6568 18.9996 13 17.6564 13 15.9996C12.9998 14.3429 11.6567 12.9996 10 12.9996Z"
            stroke="var(--strokeColor)"
            stroke-width="3"
          />
          <path
            d="M8.10059 0.309169C10.5491 -0.50812 13.246 0.331599 14.7969 2.39511C15.1288 2.83649 15.0399 3.46349 14.5986 3.7955C14.1572 4.12746 13.5302 4.03871 13.1982 3.59725C12.1645 2.22126 10.366 1.6608 8.7334 2.20565C7.10101 2.75056 6.00018 4.27867 6 5.9996V7.9996H18C19.1044 7.99965 19.9997 8.89524 20 9.9996V21.9996C19.9999 23.1041 19.1045 23.9995 18 23.9996H2C0.895453 23.9995 5.52232e-05 23.1041 0 21.9996V9.9996C0.000276174 8.89524 0.89559 7.99965 2 7.9996H4V5.9996C4.00025 3.41819 5.652 1.12662 8.10059 0.309169ZM10 12.9996C8.34328 12.9996 7.00022 14.3429 7 15.9996C7 17.6565 8.34315 18.9996 10 18.9996C11.6568 18.9996 13 17.6564 13 15.9996C12.9998 14.3429 11.6567 12.9996 10 12.9996Z"
            fill="var(--iconColor)"
          />
        </template>
        <template v-else>
          <path
            d="M10 0C13.3137 0 16 2.68629 16 6V8H18C19.1045 8.00006 19.9999 8.89545 20 10V22C19.9999 23.1045 19.1045 23.9999 18 24H2C0.895453 23.9999 5.52232e-05 23.1045 0 22V10C5.52232e-05 8.89545 0.895453 8.00006 2 8H4V6C4 2.68629 6.68629 0 10 0ZM10 13C8.34315 13 7 14.3431 7 16C7 17.6569 8.34315 19 10 19C11.6568 19 13 17.6568 13 16C13 14.3431 11.6569 13 10 13ZM10 2C7.79086 2 6 3.79086 6 6V8H14V6C14 3.79086 12.2091 2 10 2Z"
            stroke="var(--strokeColor)"
            stroke-width="3"
          />
          <path
            d="M10 0C13.3137 0 16 2.68629 16 6V8H18C19.1045 8.00006 19.9999 8.89545 20 10V22C19.9999 23.1045 19.1045 23.9999 18 24H2C0.895453 23.9999 5.52232e-05 23.1045 0 22V10C5.52232e-05 8.89545 0.895453 8.00006 2 8H4V6C4 2.68629 6.68629 0 10 0ZM10 13C8.34315 13 7 14.3431 7 16C7 17.6569 8.34315 19 10 19C11.6568 19 13 17.6568 13 16C13 14.3431 11.6569 13 10 13ZM10 2C7.79086 2 6 3.79086 6 6V8H14V6C14 3.79086 12.2091 2 10 2Z"
            fill="var(--iconColor)"
          />
        </template>
      </svg>
    </div>

    <div class="RsvpRangeInput__tickLabelList">
      <div class="RsvpRangeInput__tickLabelContainer">
        <div class="RsvpRangeInput__tickLabel" />
      </div>
      <div class="RsvpRangeInput__tickLabelContainer">
        <div
          class="RsvpRangeInput__tickLabel"
          data-testid="tickLabel"
        >
          <abbr title="3 days">3d</abbr>
        </div>
      </div>
      <div class="RsvpRangeInput__tickLabelContainer">
        <div
          class="RsvpRangeInput__tickLabel"
          data-testid="tickLabel"
        >
          <abbr title="5 days">5d</abbr>
        </div>
      </div>
      <div class="RsvpRangeInput__tickLabelContainer">
        <div
          class="RsvpRangeInput__tickLabel"
          data-testid="tickLabel"
        >
          <abbr title="7 days">7d</abbr>
        </div>
      </div>
    </div>

    <input
      v-model.number="inputModelValue"
      class="RsvpRangeInput__input"
      type="range"
      min="1"
      max="7"
      step="1"
    >
  </div>
</template>

<script lang="ts" setup>
import haptic from "@/lib/utils/platform/haptic";
import { ImpactStyle } from "@capacitor/haptics";
import { computed, ref, watch } from "vue";

const modelValue = defineModel<number | null>({
  required: true,
});

const inputModelValue = computed({
  get () {
    if (modelValue.value === null) return 1;

    return modelValue.value;
  },
  set (value: number | null) {
    modelValue.value = clampValue(value);
  },
});

const valueMin = 1;
const dayMin = 3;
const dayMax = 7;
const segmentCount = dayMax - dayMin - 1;

const ticks = ref(Array.from({
  length: dayMax - dayMin + valueMin,
}));

const direction = ref<"left" | "right">("left");
const shouldSlide = ref(false);

watch(modelValue, (newValue, oldValue) => {
  direction.value = newValue === null || oldValue && newValue > oldValue ? "right" : "left";
  shouldSlide.value = newValue === null || oldValue === null || Math.abs(newValue - oldValue) > 1;

  haptic(newValue === null || oldValue === null ? ImpactStyle.Heavy : ImpactStyle.Medium);
});

const formattedHeader = computed(() => {
  if (modelValue.value === null) return "Right away";

  return `Locked until ${modelValue.value} days before`;
});

const thumbPosition = computed(() => {
  if (modelValue.value === null || modelValue.value < dayMin) return 0;

  return modelValue.value - valueMin;
});

const thumbMax = computed(() => {
  return dayMax - valueMin;
});

function clampValue (value: number | null) {
  if (value === null || value < dayMin) return null;

  return Math.max(dayMin, Math.min(dayMax, Math.round(value)));
}
</script>

<style lang="scss" scoped>
.RsvpRangeInput {
  --thumbRadius: 16px;
  --thumbSize: calc(2 * var(--thumbRadius));
  --inputThumbSize: calc(2 * (16px + var(--thumbRadius)));
  --inputHeight: 122px;
  position: relative;

  display: grid;
  padding: 20px 16px 16px;

  border: 2px solid var(--themeColorNeutral900);
  border-radius: 6px;
  background-color: var(--themeColorInputBackground);
  box-shadow: 0 0 0 0 transparent;

  transition: 350ms;
  transition-property: box-shadow, border-color, background-color;

  &:has(:disabled) {
    border-color: var(--themeColorNeutral400);
    background-color: var(--themeColorNeutral0);
    color: var(--themeDarkTransparent500);
  }

  &:focus-within {
    box-shadow: 0 0 0 3px var(--themeColorSecondary);
  }
}

.RsvpRangeInput__header {
  position: relative;

  display: grid;
  place-items: center;
  margin-bottom: 20px;

  font: var(--fontWeightNormal) 18px/1 var(--fontFamilyMono);
}

.RsvpRangeInput__headerTitle {
  display: block;
  transition: 150ms;
  transition-property: opacity, transform;

  &.v-leave-active {
    position: absolute;
  }

  &.v-enter-from,
  &.v-leave-to {
    opacity: 0;
  }

  .RsvpRangeInput[data-direction='right'] &.v-enter-from,
  .RsvpRangeInput[data-direction='left'] &.v-leave-to {
    transform: translateX(24px);
  }

  .RsvpRangeInput[data-direction='right'] &.v-leave-to,
  .RsvpRangeInput[data-direction='left'] &.v-enter-from {
    transform: translateX(-24px);
  }
}

.RsvpRangeInput__input {
  position: absolute;
  inset: 0;

  outline: none;
  background: none;
  appearance: none;

  &::-webkit-slider-runnable-track {
    display: grid;
    align-items: center;
    height: var(--inputHeight);
  }

  &::-moz-range-track {
    display: grid;
    align-items: center;
    height: var(--inputHeight);
  }

  &::-webkit-slider-thumb {
    width: var(--inputThumbSize);
    height: var(--inputHeight);

    background-color: transparent;
    box-shadow: none;
    appearance: none;
  }

  &::-moz-range-thumb {
    width: var(--inputThumbSize);
    height: var(--inputHeight);

    border: none;
    border-radius: 0;
    background-color: transparent;
  }

  &:not(:disabled) {
    cursor: pointer;
  }
}

.RsvpRangeInput__trackContainer {
  position: relative;

  display: grid;
  align-items: center;
  height: 24px;

  pointer-events: none;
}

.RsvpRangeInput__track {
  position: relative;

  height: 6px;
  margin: 0 var(--thumbRadius);

  background-color: var(--themeColorNeutral150);

  &::before {
    --size: 18px;
    position: absolute;
    top: calc(50% - var(--size) / 2);
    left: calc(var(--size) / -2);

    width: var(--size);
    height: var(--size);

    border-radius: 50%;
    background-color: inherit;

    content: "";
  }
}

.RsvpRangeInput__trackTick {
  position: absolute;
  top: 50%;
  background-color: inherit;

  &[data-size="small"] {
    transform: translate(-1px, -50%);
    width: 2px;
    height: 16px;
  }

  &[data-size="large"] {
    transform: translate(-2px, -50%);
    width: 3px;
    height: 24px;
  }
}

.RsvpRangeInput__thumb {
  --iconColor: var(--themeColorNeutral300);
  --strokeColor: var(--colorOffBlack);
  position: absolute;
  top: calc(50% - var(--thumbRadius) - 5px);
  left: calc((100% - var(--thumbSize)) * v-bind(thumbPosition) / v-bind(thumbMax));

  overflow: visible;

  .RsvpRangeInput--shouldSlide & {
    transition: 150ms left;
  }

  .RsvpRangeInput:has(:disabled) & {
    --iconColor: var(--themeColorNeutral150);
    --strokeColor: var(--themeColorNeutral500);
  }

  :deep(path) {
    transition: 350ms;
    transition-property: stroke, fill;
  }
}

.RsvpRangeInput__tickLabelList {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  padding: 0 var(--thumbRadius);
}

.RsvpRangeInput__tickLabelContainer {
  display: flex;
  justify-content: center;
  width: 0;
}

.RsvpRangeInput__tickLabel {
  font: var(--fontWeightNormal) 16px/1 var(--fontFamilyMono);
  text-align: center;
}
</style>

